/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAlbumCollectionsQueryResponse, GetApiAlbumCollectionsQueryParams, GetApiAlbumCollections400, GetApiAlbumCollections401, GetApiAlbumCollections403, GetApiAlbumCollections500 } from "../../types/GetApiAlbumCollections.ts";
import { getApiAlbumCollectionsQueryResponseSchema } from "../../zod/AlbumCollectionSchemas/getApiAlbumCollectionsSchema.ts";

function getGetApiAlbumCollectionsUrl() {
  const res = { method: 'GET', url: `/api/album-collections` as const }  
  return res
}

/**
 * @summary Получение списка выпусков
 * {@link /api/album-collections}
 */
export async function getApiAlbumCollections({ params }: { params?: GetApiAlbumCollectionsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAlbumCollectionsQueryResponse, ResponseErrorConfig<GetApiAlbumCollections400 | GetApiAlbumCollections401 | GetApiAlbumCollections403 | GetApiAlbumCollections500>, unknown>({ method : "GET", url : getGetApiAlbumCollectionsUrl().url.toString(), params, ... requestConfig })  
  return getApiAlbumCollectionsQueryResponseSchema.parse(res.data)
}